import { Box, Button, Grid2, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
// import { quarterList, tableOffsets } from '../utils/constants'
import CustomDropDown from "./CustomDropDown";
import { dashboardsList, genderList, weekDropDown } from "../utils/constants";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { mediumGrey, pureWhite } from "../assets/colors";
import CustomTilesDropDown from "./customTilesDropDown";
import CustomDatePicker from "./CustomDatePicker";
import CustomMenu from "./CustomMenu";

const ActionBar = (props) => {
	const navigate = useNavigate();

	const isMobile = useMediaQuery("(max-width:600px)");
	const [designation, setDesignation] = React.useState(null);
	const [isStateHead, setIsStateHead] = useState(false)
	const [isDistrictHead, setIsDistrictHead] = useState(false)

	var topBoxStyle = {
		display: "flex",
		flexWrap: "wrap",
		width: "99.5%",
		border: "1px solid #D9D9D9",
		padding: "0.1rem 0.3rem 0.1rem 0rem",
		// marginTop: "10rem"
	};

	var internalBoxStyle = {
		display: "flex",
		justifyContent: "flex-start",
		flex: "1 1",
		alignItems: "center",
		width: "47%",
		padding: isMobile ? "0.1rem 0.5rem" : "0.1rem 2rem",
		flexDirection: "row"
	};
	var typographyStyle = {
		display: "flex",
		justifyContent: "center",
		alignItem: "center",
		textAlign: "center",
		verticalAlign: "center",
		// marginLeft: '1.2rem'
	};

	var buttonStyle = {
		color: "black",
		border: "1px solid #D9D9D9",
		marginRight: "0.3rem",
		fontFamily: "Helvetica",
		fontWeight: "500",
		fontSize: isMobile ? "0.7rem" : "0.9rem",
		padding: isMobile ? "0.2rem" : "0.3rem 0.5rem"
	};

	React.useEffect(() => {
		async function getDesignation() {
			let designation = await localStorage.getItem("designation");
			setDesignation(designation);
			setIsStateHead(localStorage.getItem('isStateHead'))
		}

		getDesignation();
	}, []);

	return (
		<Box style={topBoxStyle}>
			{!(props.dashBoard === "leads") && !(props.isTopDropDown) && (
				<Button
					variant="outlined"
					sx={{ ...buttonStyle, color: pureWhite, border: "1px solid white" }}
				>
					A
				</Button>
			)}

			{props.dashBoard === "leads" && (
				<>
					<CustomMenu
						designation={designation}
						tableData={props.tableData}
						setTableData={props.setTableData}
						setIsTileFilter={props.setIsTileFilter}
						setIsCustomMenuFilter={props.setIsCustomMenuFilter}
						setSelectedHierarchyFilterKey={props.setSelectedHierarchyFilterKey}
						setSelectedHeirarchyFilterContact={
							props.setSelectedHeirarchyFilterContact
						}
						setLeadStatusCheckbox={props.setLeadStatusCheckbox}
						setLeadResponseFilterArray={props.setLeadResponseFilterArray}
						setStatusFilterArray={props.setStatusFilterArray}
						setIsApplyFilterButtonClicked={props.setIsApplyFilterButtonClicked}
						setSelectedTile={props.setSelectedTile}
					></CustomMenu>
				</>
			)}

			{designation === "admin" && props.isAdmin && (
				<Box style={{ ...internalBoxStyle, justifyContent: "flex-end" }}>
					<Button
						variant="outlined"
						sx={buttonStyle}
						style={{ textTransform: "capitalize" }}
						onClick={() => {
							props.updateCreateLeaderAccDialogStatus();
						}}
					>
						Create Leader Account
					</Button>

					<Button
						variant="outlined"
						sx={buttonStyle}
						style={{ textTransform: "capitalize" }}
						onClick={() => {
							props.updateAddLeaderSupervisorDialogStatus();
						}}
					>
						Add Supervisor
					</Button>

					<Button
						variant="outlined"
						sx={buttonStyle}
						style={{ textTransform: "capitalize" }}
						onClick={() => {
							props.updateCreateAllianceDialogStatus();
						}}
					>
						Create an Alliance
					</Button>

					<Button
						variant="outlined"
						sx={buttonStyle}
						style={{ textTransform: "capitalize" }}
						onClick={() => {
							props.updateEditAllianceDialogStatus();
						}}
					>
						Edit an Alliance
					</Button>
					<Button
						variant="outlined"
						sx={buttonStyle}
						style={{ textTransform: "capitalize" }}
						onClick={() => {
							props.updateWORKerDetailsDialogStatusFunc();
						}}
					>
						Update WORKer Details
					</Button>
				</Box>
			)}

			{props.dashBoard === "Daily Task" && (
				<>
					<Box
						style={{
							...internalBoxStyle,
							justifyContent: "flex-end",
							alignItem: "centre",
						}}
					>
						{designation === "admin" && (
							<>
								<Button
									variant="outlined"
									sx={buttonStyle}
									style={{ textTransform: "capitalize" }}
									onClick={() => {
										// props.updateEditAllianceDialogStatus();
										props.updateTaskDialogStatus();
									}}
								>
									Add Tasks
								</Button>
							</>
						)}
						<CustomDatePicker
							selectedDate={props.selectedDate}
							setSelectedDate={props.setSelectedDate}
						></CustomDatePicker>
					</Box>
				</>
			)}

			{props.dashBoard === "Weekly Task" && (
				<>
					<Box style={{ ...internalBoxStyle, justifyContent: "flex-end" }}>
						<CustomTilesDropDown
							key="week"
							list={weekDropDown}
							regular={true}
							width="10rem"
							value={props.selectedWeek}
							setFunc={props.updateSelectedWeek}
						></CustomTilesDropDown>
						{/* <CustomDropDown key='week' list={weekDropDown} regular={true} width="15rem" value={props.selectedWeek} setFunc={props.updateSelectedWeek}></CustomDropDown> */}
					</Box>
				</>
			)}
			{props.dashBoard === 'WORKers' &&
				<>
					<Box style={{ ...internalBoxStyle, justifyContent: 'flex-end' }}>
						{designation === "admin" &&
							<>
								<Button sx={{ ...buttonStyle, fontSize: isMobile ? '0.6rem' : '1rem' }} style={{ textTransform: "capitalize" }}
									onClick={() =>

										props.updateAddNewWORKerDialogStatus()}
								>
									Add WORKer
								</Button>
								<Button sx={buttonStyle} style={{ textTransform: "capitalize" }}
									onClick={() =>
										props.updateAddContrAreaStatus()}
								>
									Add Volunteering Domain
								</Button>
							</>
						}
						<Button sx={buttonStyle} style={{ textTransform: "capitalize" }}
							onClick={() => props.updatePhotoVerDialogStatus()}
						>
							Photo Verification
						</Button>

					</Box>
				</>
			}

			{props.isTopDropDown &&
				<>
					<Box style={{ padding: '0.5rem', display: 'flex', alignItems: 'center', width: '65%' }}>
						{props.filterMenu}
						{designation === 'admin' &&
							<CustomDropDown
								// regular={true} 
								width='8rem'
								label='Gender'
								isCheckBox={true}
								list={genderList}
								placeHolder='Select Gender'
								value={props.genderValue}
								setFunc={props.genderSetFunc}>
							</CustomDropDown>
						}
						{
							(designation === 'admin' || isStateHead) &&
							<Box style={{ padding: '0rem 0rem 0rem 0.5rem' }}>
								<CustomDropDown
									width='17rem'
									label='State'
									isCheckBox={true}
									list={props.statesList}
									value={props.stateValue}
									setFunc={props.stateSetFunc}
								>

								</CustomDropDown>
							</Box>
						}

						<Box style={{ padding: '0rem 0rem 0rem 0.5rem' }}>
							<CustomDropDown
								width='15rem'
								label='Districts'
								isCheckBox={true}
								list={props.districtsList}
								value={props.districtValue}
								setFunc={props.districtSetFunc}
							>

							</CustomDropDown>
						</Box>
					</Box>
					<Box style={{ display: 'flex', justifyContent: 'flex-end', width: '32%' }}>
						<Button style={buttonStyle}
							onClick={() => {
								props.updateTemplateDialogStatus()
							}}
						>Templates</Button>

					</Box>

				</>

			}
			{props.dashBoard === 'Poll' &&
				<Box style={{ ...internalBoxStyle, justifyContent: 'flex-end' }}>
					<Button sx={buttonStyle} style={{ textTransform: "capitalize" }}
						onClick={() => {
							props.updateAddPollDialogStatus()
						}}
					>Add New Poll</Button>
				</Box>
			}

			{props.dashBoard === 'registrationHub' && (
				<Box style={{ ...internalBoxStyle, justifyContent: 'flex-end', width: 'auto', flexGrow: 1 }}>
					<Button
						disabled={true}
						sx={{
							...buttonStyle,
							'&.Mui-disabled': {
								// backgroundColor: mediumGrey,
								color: pureWhite,
								// cursor: 'not-allowed'
							}
						}}
						style={{ textTransform: "capitalize" }}
					>Generate Invite</Button>
				</Box>
			)}

			{props.dashboard === 'task' &&
				<>
					<Box style={{ ...internalBoxStyle, justifyContent: 'flex-end' }}>
						<Button sx={{ ...buttonStyle, fontSize: isMobile ? '0.6rem' : '1rem' }} style={{ textTransform: "capitalize" }}
							onClick={() =>

								props.updateTaskDialogStatus(true)}
						>
							Add Task
						</Button>
					</Box>
				</>
			}

			{(props.dashBoard === 'courses' || props.dashboard === 'courses') && (
				<Box style={{ ...internalBoxStyle, justifyContent: 'flex-end', width: 'auto', flexGrow: 1 }}>
					<Button sx={buttonStyle} style={{ textTransform: "capitalize" }}
						onClick={() => props.onAddCourse()}
					>Add New Course/ Quiz</Button>
				</Box>
			)}

		</Box>
	);
};

export default ActionBar;
